module.exports = __webpack_public_path__ + "img/slideVerify_11.4f1b3760.png";